import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ITSupportHero from './components/ITSupportHero';
import ITSupportIntro from './components/ITSupportIntro';
import ITSupportSubsidy from './components/ITSupportSubsidy';
import ITSupportFeature from './components/ITSupportFeature';
import ITSupportFlow from './components/ITSupportFlow';
import ITSupportPreparation from './components/ITSupportPreparation';

const ITSupportPage = () => {
  useEffect(() => {
    // ページタイトルとメタ情報の設定
    document.title = 'IT導入支援事業 | 株式会社MSK';
    
    const metaUpdates: Array<{ selector: string; content: string }> = [
      { selector: 'meta[property="og:title"]', content: 'IT導入支援事業 | 株式会社MSK' },
      { selector: 'meta[name="twitter:title"]', content: 'IT導入支援事業 | 株式会社MSK' },
      { selector: 'meta[name="description"]', content: 'IT導入補助金を活用したサイト制作をサポートいたします。株式会社MSKのIT導入支援事業についてご紹介します。' },
      { selector: 'meta[property="og:description"]', content: 'IT導入補助金を活用したサイト制作をサポートいたします。株式会社MSKのIT導入支援事業についてご紹介します。' },
      { selector: 'meta[property="og:url"]', content: window.location.href },
    ];

    metaUpdates.forEach(({ selector, content }) => {
      const element = document.querySelector(selector);
      if (element) element.setAttribute('content', content);
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <ITSupportHero />
        <ITSupportIntro />
        <ITSupportSubsidy />
        <ITSupportFeature />
        <ITSupportFlow />
        <ITSupportPreparation />
      </main>
      <Footer />
    </div>
  );
};

export default ITSupportPage;